import * as React from 'react'
import { LIGHTER_GRAY, WHITE } from '@omnilert/components'

/**
 * Renders a right-pointing caret/chevron SVG icon
 * @returns {JSX.Element} Caret right icon SVG element
 */
function CaretRight() {
  return (
    <svg
      fill='none'
      height={20}
      viewBox='0 0 10 17'
      width={10}
    >
      <g clipPath='url(#prefix__clip0)'>
        <path
          d='M.68 16.32l8.552-7.566a.34.34 0 000-.508L.68.68'
          stroke={LIGHTER_GRAY}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={1.36}
        />
      </g>
      <defs>
        <clipPath id='prefix__clip0'>
          <path
            d='M0 0h10.2v17H0z'
            fill={WHITE}
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CaretRight
